<template>
  <!-- Title of box (mySide) -->
  <div>
    <div class="title-position">
      <font-awesome-icon
        v-if="game"
        :icon="faShareAlt"
        class="share-position-icon"
        role="button"
        tabindex="0"
        aria-label="Share position"
        @click.stop="openShareSlip"
      />
      <div class="row text-center" @click="changeAccordeonOpened">
        <div
          v-if="
            typeBet === 'moneyline' &&
            !(
              (riskTeam1 < 0 && riskTeam2 < 0) ||
              (winTeam1 < 0 && winTeam2 < 0)
            )
          "
          class="col-md-11 col-12"
        >
          {{ objSide.mySide.moneyLineName }}
          <span v-if="objSide.mySide.odds !== 0">{{
            formatOddsNoCommission(objSide.mySide.odds)
          }}</span>
          <span class="bar-separate">&nbsp; | &nbsp;</span> Risk ${{
            objSide.mySide.risk
          }}
          <span class="bar-separate">&nbsp; | &nbsp;</span> Win ${{
            objSide.mySide.win
          }}
        </div>
        <div
          v-else-if="
            typeBet === 'moneyline' &&
            ((riskTeam1 < 0 && riskTeam2 < 0) || (winTeam1 < 0 && winTeam2 < 0))
          "
          class="col-md-11 col-12"
        >
          {{ team1Name }} Win ${{ winTeam1 }}
          <span class="bar-separate">&nbsp; | &nbsp;</span> {{ team2Name }} Win
          ${{ winTeam2 }}
        </div>
        <div
          v-else-if="
            typeBet === 'spread' &&
            !(
              (riskTeam1 < 0 && riskTeam2 < 0) ||
              (winTeam1 < 0 && winTeam2 < 0)
            )
          "
          class="col-md-11 col-12"
        >
          {{ objSide.mySide.spreadName }} {{ sign(objSide.mySide.spread) }}
          <span v-if="objSide.mySide.odds !== 0">{{
            formatOddsNoCommission(objSide.mySide.odds)
          }}</span>
          <span class="bar-separate">&nbsp; | &nbsp;</span> Risk ${{
            objSide.mySide.risk
          }}
          <span class="bar-separate">&nbsp; | &nbsp;</span> Win ${{
            objSide.mySide.win
          }}
        </div>
        <div
          v-else-if="
            typeBet === 'spread' &&
            ((riskTeam1 < 0 && riskTeam2 < 0) || (winTeam1 < 0 && winTeam2 < 0))
          "
          class="col-md-11 col-12"
        >
          {{ team1Name }} Win ${{ winTeam1 }}
          <span class="bar-separate">&nbsp; | &nbsp;</span> {{ team2Name }} Win
          ${{ winTeam2 }}
        </div>
        <div
          v-else-if="
            typeBet === 'total' &&
            !(
              (riskTeam1 < 0 && riskTeam2 < 0) ||
              (winTeam1 < 0 && winTeam2 < 0)
            )
          "
          class="col-md-11 col-12"
        >
          {{ objSide.mySide.totalName }} {{ objSide.mySide.total }}
          <span v-if="objSide.mySide.odds !== 0">{{
            formatOddsNoCommission(objSide.mySide.odds)
          }}</span>
          <span class="bar-separate">&nbsp; | &nbsp;</span> Risk ${{
            objSide.mySide.risk
          }}
          <span class="bar-separate">&nbsp; | &nbsp;</span> Win ${{
            objSide.mySide.win
          }}
        </div>
        <div
          v-else-if="
            typeBet === 'total' &&
            ((riskTeam1 < 0 && riskTeam2 < 0) || (winTeam1 < 0 && winTeam2 < 0))
          "
          class="col-md-11 col-12"
        >
          {{ team1Name }} {{ objSide.mySide.total }} ${{ winTeam1 }}
          <span class="bar-separate">&nbsp; | &nbsp;</span> {{ team2Name }}
          {{ objSide.mySide.total }} ${{ winTeam2 }}
        </div>
        <div
          v-if="
            typeBet === 'moneyline1x2' &&
            !(
              (riskTeam1 < 0 && riskTeam2 < 0) ||
              (winTeam1 < 0 && winTeam2 < 0)
            )
          "
          class="col-md-11 col-12"
        >
          <div v-if="homeAway === 'away'">
            {{ objSide.mySideAway.moneyLine1x2Name }}
            <span v-if="objSide.mySideAway.odds !== 0">{{
              formatOddsNoCommission(objSide.mySideAway.odds)
            }}</span>
            <span class="bar-separate">&nbsp; | &nbsp;</span> Risk ${{
              objSide.mySideAway.risk
            }}
            <span class="bar-separate">&nbsp; | &nbsp;</span> Win ${{
              objSide.mySideAway.win
            }}
          </div>
          <div v-else-if="homeAway === 'home'">
            {{ objSide.mySideHome.moneyLine1x2Name }}
            <span v-if="objSide.mySideHome.odds !== 0">{{
              formatOddsNoCommission(objSide.mySideHome.odds)
            }}</span>
            <span class="bar-separate">&nbsp; | &nbsp;</span> Risk ${{
              objSide.mySideHome.risk
            }}
            <span class="bar-separate">&nbsp; | &nbsp;</span> Win ${{
              objSide.mySideHome.win
            }}
          </div>
          <div v-if="homeAway === 'draw'">
            {{ objSide.mySideDraw.moneyLine1x2Name }}
            <span v-if="objSide.mySideDraw.odds !== 0">{{
              formatOddsNoCommission(objSide.mySideDraw.odds)
            }}</span>
            <span class="bar-separate">&nbsp; | &nbsp;</span> Risk ${{
              objSide.mySideDraw.risk
            }}
            <span class="bar-separate">&nbsp; | &nbsp;</span> Win ${{
              objSide.mySideDraw.win
            }}
          </div>
        </div>
        <div
          v-else-if="
            typeBet === 'moneyline1x2' &&
            ((riskTeam1 < 0 && riskTeam2 < 0) || (winTeam1 < 0 && winTeam2 < 0))
          "
          class="col-md-11 col-12"
        >
          {{ team1Name }} Win ${{ winTeam1 }}
          <span class="bar-separate">&nbsp; | &nbsp;</span> {{ team2Name }} Win
          ${{ winTeam2 }}
        </div>
        <div
          class="col-1 d-md-flex d-none justify-content-center flex-nowrap align-items-center bet-plus"
        >
          <font-awesome-icon
            :icon="objSide.expanded ? faChevronUp : faChevronDown"
            class="iconAccordeon"
          />
        </div>
      </div>
    </div>
    <div
      v-if="objSide.expanded"
      class="col-12 mx-0 py-1 mb-1 player-chart-header"
    >
      <div class="col-12">
        <div class="row">
          <div
            class="col-2 d-none d-md-flex justify-content-center flex-nowrap align-items-center"
          >
            START
          </div>
          <div
            class="col-md-6 col-lg-5 col-10 justify-content-center flex-nowrap align-items-center bet-main-info"
          >
            YOUR SIDE - GAME INFO
          </div>
          <div
            class="col-1 d-none d-md-flex justify-content-center flex-nowrap align-items-center"
          >
            RISK
          </div>
          <div
            class="col-lg-1 col-md-2 d-none d-md-flex justify-content-center flex-nowrap align-items-center"
          >
            WIN
          </div>
          <div
            class="col-md-none col-2 d-md-none d-flex justify-content-center flex-nowrap align-items-center smallText"
          >
            RISK/WIN
          </div>
          <div
            class="col-lg-2 d-none d-lg-flex justify-content-center flex-nowrap align-items-center"
          >
            TYPE
          </div>
          <div
            class="col-md-1 d-none d-md-flex justify-content-center flex-nowrap align-items-center"
          >
            INFO
          </div>
        </div>
      </div>
    </div>
    <share-slip-modal
      v-if="shareSlipShown"
      :slip="sharePayload"
      @close-modal="shareSlipShown = false"
    />
  </div>
</template>

<script setup>
//CORE
import { formatOddsNoCommission, sign } from '@/core/oddsFormatUtils';
import { capitalize } from '@/core/utils';
import { buildSharePayloadFromCombined } from '@/core/shareSlipUtils';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons/faShareAlt';
import { ref, onMounted } from 'vue';

//COMPONENTS
import ShareSlipModal from '@/components/userBets/modals/ShareSlipModal.vue';

//PROPS
const props = defineProps({
  objSide: {
    type: Object,
    required: true,
  },
  typeBet: {
    type: String,
    default: 'spread',
  },
  keyObj: {
    type: String,
    required: true,
  },
  homeAway: {
    type: String,
    required: false,
    default: 'none',
  },
  game: {
    type: Object,
    default: null,
  },
});

//CONST
const riskTeam1 = ref(0);
const riskTeam2 = ref(0);
const winTeam1 = ref(0);
const winTeam2 = ref(0);
const team1Name = ref('');
const team2Name = ref('');

//HOOK
onMounted(() => {
  calculateRiskWin();
});

//FUNCTIONS
function calculateRiskWin() {
  if (
    (props.objSide.home && props.objSide.away) ||
    (props.objSide.over && props.objSide.under) ||
    (props.objSide.awayYes && props.objSide.awayNo) ||
    (props.objSide.homeYes && props.objSide.homeNo) ||
    (props.objSide.drawYes && props.objSide.drawNo)
  ) {
    if (props.objSide.mySide.moneyLineName) {
      riskTeam1.value =
        props.objSide.home.sumRiskBets - props.objSide.away.sumWinBets;
      riskTeam2.value =
        props.objSide.away.sumRiskBets - props.objSide.home.sumWinBets;

      winTeam1.value =
        Math.round(
          props.objSide.home.sumWinBets - props.objSide.away.sumRiskBets,
        ) >
        Math.round(
          props.objSide.away.sumWinBets - props.objSide.home.sumRiskBets,
        )
          ? Math.round(
              props.objSide.home.sumWinBets - props.objSide.away.sumRiskBets,
            )
          : Math.round(
              props.objSide.away.sumWinBets - props.objSide.home.sumRiskBets,
            );
      winTeam2.value =
        Math.round(
          props.objSide.home.sumWinBets - props.objSide.away.sumRiskBets,
        ) >
        Math.round(
          props.objSide.away.sumWinBets - props.objSide.home.sumRiskBets,
        )
          ? Math.round(
              props.objSide.away.sumWinBets - props.objSide.home.sumRiskBets,
            )
          : Math.round(
              props.objSide.home.sumWinBets - props.objSide.away.sumRiskBets,
            );
      team1Name.value =
        props.objSide.mySide.moneyLineName ===
        props.objSide.home.participantInfo.longName
          ? props.objSide.home.participantInfo.longName
          : props.objSide.away.participantInfo.longName;
      team2Name.value =
        props.objSide.mySide.moneyLineName ===
        props.objSide.home.participantInfo.longName
          ? props.objSide.away.participantInfo.longName
          : props.objSide.home.participantInfo.longName;
    } else if (props.objSide.mySide.spreadName) {
      if (props.objSide.home)
        riskTeam1.value =
          props.objSide.home.sumRiskBets - props.objSide.away.sumWinBets;
      if (props.objSide.away)
        riskTeam2.value =
          props.objSide.away.sumRiskBets - props.objSide.home.sumWinBets;
      winTeam1.value =
        Math.round(
          props.objSide.home.sumWinBets - props.objSide.away.sumRiskBets,
        ) >
        Math.round(
          props.objSide.away.sumWinBets - props.objSide.home.sumRiskBets,
        )
          ? Math.round(
              props.objSide.home.sumWinBets - props.objSide.away.sumRiskBets,
            )
          : Math.round(
              props.objSide.away.sumWinBets - props.objSide.home.sumRiskBets,
            );
      winTeam2.value =
        Math.round(
          props.objSide.home.sumWinBets - props.objSide.away.sumRiskBets,
        ) >
        Math.round(
          props.objSide.away.sumWinBets - props.objSide.home.sumRiskBets,
        )
          ? Math.round(
              props.objSide.away.sumWinBets - props.objSide.home.sumRiskBets,
            )
          : Math.round(
              props.objSide.home.sumWinBets - props.objSide.away.sumRiskBets,
            );

      team1Name.value =
        props.objSide.mySide.spreadName ===
        props.objSide.home.participantInfo.longName
          ? props.objSide.home.participantInfo.longName
          : props.objSide.away.participantInfo.longName;
      team2Name.value =
        props.objSide.mySide.spreadName ===
        props.objSide.home.participantInfo.longName
          ? props.objSide.away.participantInfo.longName
          : props.objSide.home.participantInfo.longName;
    } else if (props.objSide.mySide.totalName) {
      riskTeam1.value =
        props.objSide.over.sumRiskBets - props.objSide.under.sumWinBets;
      riskTeam2.value =
        props.objSide.under.sumRiskBets - props.objSide.over.sumWinBets;
      winTeam1.value =
        Math.round(
          props.objSide.over.sumWinBets - props.objSide.under.sumRiskBets,
        ) >
        Math.round(
          props.objSide.under.sumWinBets - props.objSide.over.sumRiskBets,
        )
          ? Math.round(
              props.objSide.over.sumWinBets - props.objSide.under.sumRiskBets,
            )
          : Math.round(
              props.objSide.under.sumWinBets - props.objSide.over.sumRiskBets,
            );
      winTeam2.value =
        Math.round(
          props.objSide.over.sumWinBets - props.objSide.under.sumRiskBets,
        ) >
        Math.round(
          props.objSide.under.sumWinBets - props.objSide.over.sumRiskBets,
        )
          ? Math.round(
              props.objSide.under.sumWinBets - props.objSide.over.sumRiskBets,
            )
          : Math.round(
              props.objSide.over.sumWinBets - props.objSide.under.sumRiskBets,
            );

      team1Name.value =
        props.objSide.mySide.totalName === 'Over' ? 'Over' : 'Under';
      team2Name.value =
        props.objSide.mySide.totalName === 'Over' ? 'Under' : 'Over';
    } else if (
      props.objSide.mySideAway.moneyLine1x2Name ||
      props.objSide.mySideHome.moneyLine1x2Name ||
      props.objSide.mySideDraw.moneyLine1x2Name
    ) {
      if (props.homeAway === 'away') {
        riskTeam1.value =
          props.objSide.awayNo.sumRiskBets - props.objSide.awayYes.sumWinBets;
        riskTeam2.value =
          props.objSide.awayYes.sumRiskBets - props.objSide.awayNo.sumWinBets;

        winTeam1.value =
          Math.round(
            props.objSide.awayNo.sumWinBets - props.objSide.awayYes.sumRiskBets,
          ) >
          Math.round(
            props.objSide.awayYes.sumWinBets - props.objSide.awayNo.sumRiskBets,
          )
            ? Math.round(
                props.objSide.awayNo.sumWinBets -
                  props.objSide.awayYes.sumRiskBets,
              )
            : Math.round(
                props.objSide.awayYes.sumWinBets -
                  props.objSide.awayNo.sumRiskBets,
              );
        winTeam2.value =
          Math.round(
            props.objSide.awayNo.sumWinBets - props.objSide.awayYes.sumRiskBets,
          ) >
          Math.round(
            props.objSide.awayYes.sumWinBets - props.objSide.awayNo.sumRiskBets,
          )
            ? Math.round(
                props.objSide.awayYes.sumWinBets -
                  props.objSide.awayNo.sumRiskBets,
              )
            : Math.round(
                props.objSide.awayNo.sumWinBets -
                  props.objSide.awayYes.sumRiskBets,
              );
        team1Name.value = props.objSide.mySideAway.moneyLine1x2Name;
        team2Name.value = props.objSide.mySideAway.moneyLine1x2Name.includes(
          'YES',
        )
          ? props.objSide.mySideAway.moneyLine1x2Name.replace('YES', 'NO')
          : props.objSide.mySideAway.moneyLine1x2Name.replace('NO', 'YES');
      } else if (props.homeAway === 'home') {
        riskTeam1.value =
          props.objSide.homeNo.sumRiskBets - props.objSide.homeYes.sumWinBets;
        riskTeam2.value =
          props.objSide.homeYes.sumRiskBets - props.objSide.homeNo.sumWinBets;

        winTeam1.value =
          Math.round(
            props.objSide.homeNo.sumWinBets - props.objSide.homeYes.sumRiskBets,
          ) >
          Math.round(
            props.objSide.homeYes.sumWinBets - props.objSide.homeNo.sumRiskBets,
          )
            ? Math.round(
                props.objSide.homeNo.sumWinBets -
                  props.objSide.homeYes.sumRiskBets,
              )
            : Math.round(
                props.objSide.homeYes.sumWinBets -
                  props.objSide.homeNo.sumRiskBets,
              );
        winTeam2.value =
          Math.round(
            props.objSide.homeNo.sumWinBets - props.objSide.homeYes.sumRiskBets,
          ) >
          Math.round(
            props.objSide.homeYes.sumWinBets - props.objSide.homeNo.sumRiskBets,
          )
            ? Math.round(
                props.objSide.homeYes.sumWinBets -
                  props.objSide.homeNo.sumRiskBets,
              )
            : Math.round(
                props.objSide.homeNo.sumWinBets -
                  props.objSide.homeYes.sumRiskBets,
              );
        team1Name.value = props.objSide.mySideHome.moneyLine1x2Name;
        team2Name.value = props.objSide.mySideHome.moneyLine1x2Name.includes(
          'YES',
        )
          ? props.objSide.mySideHome.moneyLine1x2Name.replace('YES', 'NO')
          : props.objSide.mySideHome.moneyLine1x2Name.replace('NO', 'YES');
      } else if (props.homeAway === 'draw') {
        riskTeam1.value =
          props.objSide.drawNo.sumRiskBets - props.objSide.drawYes.sumWinBets;
        riskTeam2.value =
          props.objSide.drawYes.sumRiskBets - props.objSide.drawNo.sumWinBets;

        winTeam1.value =
          Math.round(
            props.objSide.drawNo.sumWinBets - props.objSide.drawYes.sumRiskBets,
          ) >
          Math.round(
            props.objSide.drawYes.sumWinBets - props.objSide.drawNo.sumRiskBets,
          )
            ? Math.round(
                props.objSide.drawNo.sumWinBets -
                  props.objSide.drawYes.sumRiskBets,
              )
            : Math.round(
                props.objSide.drawYes.sumWinBets -
                  props.objSide.drawNo.sumRiskBets,
              );
        winTeam2.value =
          Math.round(
            props.objSide.drawNo.sumWinBets - props.objSide.drawYes.sumRiskBets,
          ) >
          Math.round(
            props.objSide.drawYes.sumWinBets - props.objSide.drawNo.sumRiskBets,
          )
            ? Math.round(
                props.objSide.drawYes.sumWinBets -
                  props.objSide.drawNo.sumRiskBets,
              )
            : Math.round(
                props.objSide.drawNo.sumWinBets -
                  props.objSide.drawYes.sumRiskBets,
              );
        team1Name.value = props.objSide.mySideDraw.moneyLine1x2Name;
        team2Name.value = props.objSide.mySideDraw.moneyLine1x2Name.includes(
          'YES',
        )
          ? props.objSide.mySideDraw.moneyLine1x2Name.replace('YES', 'NO')
          : props.objSide.mySideDraw.moneyLine1x2Name.replace('NO', 'YES');
      }
    }
  }
}

//SHARE
const shareSlipShown = ref(false);
const sharePayload = ref(null);

// Same condition the template branches on: when both sides show a negative
// risk (or negative win), the position is hedged and the header stops naming a
// single pick, showing "Team1 Win $X | Team2 Win $Y" instead.
function isHedged() {
  return (
    (riskTeam1.value < 0 && riskTeam2.value < 0) ||
    (winTeam1.value < 0 && winTeam2.value < 0)
  );
}

// Mirrors the header's own display logic: side name + line + average odds.
function sideSummary() {
  const s = props.objSide || {};
  if (props.typeBet === 'moneyline1x2') {
    const my =
      props.homeAway === 'away'
        ? s.mySideAway
        : props.homeAway === 'home'
          ? s.mySideHome
          : s.mySideDraw;
    return {
      name: my?.moneyLine1x2Name || '',
      odds: my?.odds || 0,
      risk: my?.risk,
      win: my?.win,
    };
  }
  const my = s.mySide || {};
  if (props.typeBet === 'spread') {
    return {
      name: `${my.spreadName || ''} ${my.spread !== undefined ? sign(my.spread) : ''}`.trim(),
      odds: my.odds || 0,
      risk: my.risk,
      win: my.win,
    };
  }
  if (props.typeBet === 'total') {
    return {
      name: `${my.totalName || ''} ${my.total ?? ''}`.trim(),
      odds: my.odds || 0,
      risk: my.risk,
      win: my.win,
    };
  }
  return {
    name: my.moneyLineName || '',
    odds: my.odds || 0,
    risk: my.risk,
    win: my.win,
  };
}

// Latest matched time across every bet aggregated under this side group.
function latestAcceptedTime() {
  const groupKeys = [
    'home',
    'away',
    'over',
    'under',
    'awayYes',
    'awayNo',
    'homeYes',
    'homeNo',
    'drawYes',
    'drawNo',
  ];
  let latest = null;
  groupKeys.forEach((key) => {
    const bets = props.objSide?.[key]?.bets || [];
    bets.forEach((bet) => {
      const time = bet.matchedTime || bet.createdAt;
      if (time && (!latest || new Date(time) > new Date(latest))) latest = time;
    });
  });
  return latest;
}

function matchupLabel() {
  const participants = props.game?.participants;
  if (Array.isArray(participants) && participants.length >= 2) {
    const first = participants[0]?.shortName || participants[0]?.longName;
    const second = participants[1]?.shortName || participants[1]?.longName;
    return `${first || ''} @ ${second || ''}`.trim();
  }
  return props.game?.eventName || '';
}

function openShareSlip() {
  const base = {
    matchup: matchupLabel(),
    league: props.game?.league || '',
    startTime: props.game?.start || null,
    acceptedTime: latestAcceptedTime(),
  };

  // Hedged: the header names no single pick, so neither does the card. Both
  // outcomes win, so share the guaranteed amount rather than RISK/TO WIN
  // tiles that would misrepresent a two-sided position (and could print a
  // negative risk).
  if (isHedged()) {
    const worst = Math.min(winTeam1.value, winTeam2.value);
    const best = Math.max(winTeam1.value, winTeam2.value);
    sharePayload.value = buildSharePayloadFromCombined({
      ...base,
      pick: matchupLabel(),
      risk: 0,
      win: best,
      typeLabel: 'Hedged Position',
      outcome: 'win',
      outcomeLabel: 'LOCKED',
      amount: worst,
    });
    shareSlipShown.value = true;
    return;
  }

  const summary = sideSummary();
  const pick = `${summary.name} ${
    summary.odds !== 0 ? formatOddsNoCommission(summary.odds) : ''
  }`.trim();
  sharePayload.value = buildSharePayloadFromCombined({
    ...base,
    pick: pick || matchupLabel(),
    risk: summary.risk,
    win: summary.win,
    typeLabel: 'Position',
  });
  shareSlipShown.value = true;
}

//EMITTERS
const emit = defineEmits(['changeAccordeonOpened']);
function changeAccordeonOpened() {
  if (props.homeAway === 'none') {
    emit('changeAccordeonOpened', props.keyObj);
  } else {
    emit('changeAccordeonOpened', {
      keyObj: props.keyObj,
      homeAway: props.homeAway,
    });
  }
}
</script>
<style scoped lang="scss">
@use 'sass:map';
@use '@/scss/tokens.scss' as main;

.title-position {
  background: main.$blue-702_01;
  color: main.$white;
  font-size: small;
  font-weight: main.$font-weight-bold;
  padding: 8px;
  margin: 0;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  cursor: pointer;
  position: relative;

  /* At night the stock token is a saturated navy (#272d58) sitting on the
     modal's own navy body, so bar and body landed on the same hue and the
     panel read as one blue wash with no header. The bar tucks a step UNDER
     the group card instead — the same move the exchange card's market-head
     band makes — which separates it without leaving the navy family.

     It has to be a translucent DARKENING rather than a flat hex, because the
     card underneath is not one colour. `.box-position` resolves to
     `$white_01`, and that token is re-defined per view: #2e3459 on Exchange
     and Sportsbook, the stock #222744 on SingleGameMarket and MonkeyMachine,
     and #262d52 inside the neutral My Positions panel. A hex tuned against
     any one of those disappears against the others — an earlier revision of
     this line was #1f2748, which read correctly on Exchange and was invisible
     on the single-game board. Darkening whatever is behind it holds on all
     four. */
  [theme='night'] & {
    background: rgba(9, 11, 28, 0.45);
  }
}

/* Sits inside the navy bar, left of the collapse chevron (which the share
   icon replaces as the rightmost control on mobile, where the chevron col
   is hidden). */
.share-position-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 3rem;
  color: main.$white;
  font-size: 14px;
  cursor: pointer;
  z-index: 2;

  &:hover {
    opacity: 0.8;
  }

  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    right: 0.7rem;
  }
}

.bet {
  color: main.$blue-1100;
  font-size: small;
  margin: 0;
  width: 100%;
  border-top: 1px solid main.$grey-1000;
  background: main.$white;

  &-main-info {
    text-transform: uppercase;
    font-weight: main.$font-weight-bold;
    font-size: main.$font-size-sm;
  }

  &-plus {
    font-size: main.$font-size-sm;
    color: main.$white;
    cursor: pointer;
    font-weight: main.$font-weight-bold;
  }
}
/* A column caption, not a pick. bet-main-info is the loudest type in a bet
   row, so reset it to the header's own size when it lands in the header. */
.player-chart-header .bet-main-info {
  font-size: inherit;
}

.smallText {
  display: none;
}

.bar-separate {
  text-align: center;
  font-size: 12px;
  color: main.$blue-202;
}

svg[data-icon='chevron-up'],
svg[data-icon='chevron-down'] {
  color: main.$white;
}

svg[data-icon='plus'] {
  padding: 2px;
  font-size: 12px;
  background: main.$blue-404;
  border-radius: 360px;
}

svg[data-icon='plus']:hover {
  opacity: 0.9;
}

.short-info {
  font-size: small;
  font-weight: bold;
  color: main.$blue-702;
  text-align: center;
}

.jump {
  min-width: 10%;
}

.iconAccordeon {
  color: main.$color-primary;
}

.player-chart-header {
  font-weight: 600;
  color: main.$blue-1100;
  /* A column caption, not a surface: quiet tracked type, same in both themes. */
  font-size: 0.6875rem;
  letter-spacing: 0.06em;
  border-radius: 4px;
  margin: 0;
  width: 100%;
  box-shadow: 0 2px 4px 0 main.$blue-1200;
  padding: 4px;
  border: 3px;

  /* At night the stock shadow reads as a halo around a floating bar. */
  [theme='night'] & {
    box-shadow: none;
    color: #969ccb;
  }

  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    display: none;
  }
}

.spacing-vertical {
  height: 0px;

  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    .spacing-vertical {
      height: 15px;
    }
  }
}

.smallText {
  font-size: xx-small;
}

.bet-list {
  border: 1px solid main.$grey-1000;
}
</style>
